function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { IPO_CAMPAIGN_ID } from "constants/sales/campaigns";
import { getHubspotHowCanHelpInput, HUBSPOT_COMPANY_INPUT, HUBSPOT_COMPANY_INPUT_WITH_PLACEHOLDER, HUBSPOT_COMPANYSIZE_INPUT, HUBSPOT_COMPANYSIZE_INPUT_WITH_PLACEHOLDER, HUBSPOT_EMAIL_INPUT, HUBSPOT_EMAIL_INPUT_WITH_PLACEHOLDER, HUBSPOT_FIRSTNAME_INPUT, HUBSPOT_FIRSTNAME_INPUT_WITH_PLACEHOLDER, HUBSPOT_HOWPLANUSE_INPUT, HUBSPOT_JOBTITLE_INPUT, HUBSPOT_JOBTITLE_INPUT_WITH_PLACEHOLDER, HUBSPOT_LASTNAME_INPUT, HUBSPOT_LASTNAME_INPUT_WITH_PLACEHOLDER, HUBSPOT_PHONE_INPUT, HUBSPOT_PRODUCT_QUESTION_INPUT, HUBSPOT_PRODUCT_QUESTION_INPUT_WITH_HUBSPOT_LABEL, HUBSPOT_PRODUCT_QUESTION_INPUT_WITH_PLACEHOLDER } from "./hubspot-inputs";
export const PORTAL_ID = "5945317";
export const TEST_PORTAL_ID = "22796107";
export const CONTACT_SALES_HUBSPOT_FORM_ID = "215c1dc9-0c3c-44ad-be61-add5f71dfe22";
// Legacy form IDs — still supported when already configured, but no longer selectable in the CMS
export const REQUEST_A_DEMO_HUBSPOT_FORM_ID = "1027e76f-6a94-489b-8ee3-e6d8141cc0f6";
export const REPORT_FORM_ID = "1091544b-bff2-40ef-aada-8acfea9089b3";
export const NURTURE_CONTACT_US_FORM_ID = "38593c14-af5b-4f56-8d3b-a403dee4266b";
export const EMAIL_ONLY_FORM_ID = "c46e9209-b721-472f-8c2e-b151cba6d12e";
export const EVENTS_HUBSPOT_FORM_ID = "192ded92-8c95-44bd-bf4e-1fcf0a32c0c2";
// used for testing only
export const TEST_CONTACT_SALES_HUBSPOT_FORM_ID = "6fe93320-3033-4c28-9215-c19b535ebcae";
// New form IDs — selectable in the CMS; lead source and pre-selected product are derived automatically
export const CONTACT_SALES_LANDING_PAGE_SERVICE_FORM_ID = "39426226-227f-4f83-a41d-1a0e015f2c40";
export const CONTACT_SALES_LANDING_PAGE_CRM_FORM_ID = "99991948-4e5f-478b-93fa-fcc09c1a85ef";
export const CONTACT_SALES_LANDING_PAGE_AGENT_FACTORY_FORM_ID = "d19c6db6-024d-4109-8a36-c230ac324824";
export const CONTACT_SALES_LANDING_PAGE_WORK_MANAGEMENT_FORM_ID = "e7fb1940-b186-43bf-9258-2160a2d99edb";
export const CONTACT_SALES_LANDING_PAGES_FDES_FORM_ID = "5df9bac4-486c-4550-bb0e-472874a7c2f8";
export const CONTACT_SALES_LANDING_PAGE_MONDAY_VIBE_FORM_ID = "45383fc6-404a-4800-973e-7fb7339a8af8";
export const CONTACT_SALES_LANDING_PAGE_GENERAL_FORM_ID = "635994d2-fa27-4e9e-b429-8d6a8d6c6714";
export const CONTACT_US_MOBILE_CONTACT_SALES_FORM_ID = "cd2b09e0-2dfb-4d7d-a4de-9d266e0bfb67";
export const CONTACT_SALES_EXPANSION_FORM_ID = "8a12149d-d3b0-4d78-9f2a-dbde2c41a250";
export const CONTACT_SALES_WEBSITE_CRM_FORM_ID = "55f1d96d-afc3-400a-aa8e-c0003f1ae972";
const LANDING_PAGE_CONTACT_SALES_LEAD_SOURCE = "Landing Page - Contact Sales";
const MOBILE_CONTACT_SALES_LEAD_SOURCE = "Mobile - Contact Sales";
const WEBSITE_CONTACT_SALES_LEAD_SOURCE = "Website - Contact Sales";
// Maps each new form ID to its hardcoded lead source and pre-selected product.
// Forms without a preSelectedProduct will show the product question to the user.
const CONTACT_SALES_BUTTON_TEXT_KEY = "contactSales.hubspotForm.form.contactSalesButton";
const NEW_FORM_METADATA = {
    [CONTACT_SALES_LANDING_PAGE_SERVICE_FORM_ID]: {
        leadSource: LANDING_PAGE_CONTACT_SALES_LEAD_SOURCE,
        preSelectedProduct: "Ticketing & service management",
        submitButtonTextKey: CONTACT_SALES_BUTTON_TEXT_KEY
    },
    [CONTACT_SALES_LANDING_PAGE_CRM_FORM_ID]: {
        leadSource: LANDING_PAGE_CONTACT_SALES_LEAD_SOURCE,
        preSelectedProduct: "Sales & CRM",
        submitButtonTextKey: CONTACT_SALES_BUTTON_TEXT_KEY
    },
    [CONTACT_SALES_LANDING_PAGE_AGENT_FACTORY_FORM_ID]: {
        leadSource: LANDING_PAGE_CONTACT_SALES_LEAD_SOURCE,
        preSelectedProduct: "Work & project management",
        submitButtonTextKey: CONTACT_SALES_BUTTON_TEXT_KEY
    },
    [CONTACT_SALES_LANDING_PAGE_WORK_MANAGEMENT_FORM_ID]: {
        leadSource: LANDING_PAGE_CONTACT_SALES_LEAD_SOURCE,
        preSelectedProduct: "Work & project management",
        submitButtonTextKey: CONTACT_SALES_BUTTON_TEXT_KEY
    },
    [CONTACT_SALES_LANDING_PAGES_FDES_FORM_ID]: {
        leadSource: LANDING_PAGE_CONTACT_SALES_LEAD_SOURCE,
        preSelectedProduct: "Work & project management",
        submitButtonTextKey: CONTACT_SALES_BUTTON_TEXT_KEY
    },
    [CONTACT_SALES_LANDING_PAGE_MONDAY_VIBE_FORM_ID]: {
        leadSource: LANDING_PAGE_CONTACT_SALES_LEAD_SOURCE,
        preSelectedProduct: null,
        submitButtonTextKey: CONTACT_SALES_BUTTON_TEXT_KEY
    },
    [CONTACT_SALES_LANDING_PAGE_GENERAL_FORM_ID]: {
        leadSource: LANDING_PAGE_CONTACT_SALES_LEAD_SOURCE,
        preSelectedProduct: null,
        submitButtonTextKey: CONTACT_SALES_BUTTON_TEXT_KEY
    },
    [CONTACT_US_MOBILE_CONTACT_SALES_FORM_ID]: {
        leadSource: MOBILE_CONTACT_SALES_LEAD_SOURCE,
        preSelectedProduct: null,
        submitButtonTextKey: CONTACT_SALES_BUTTON_TEXT_KEY
    },
    [CONTACT_SALES_EXPANSION_FORM_ID]: {
        leadSource: WEBSITE_CONTACT_SALES_LEAD_SOURCE,
        preSelectedProduct: null,
        submitButtonTextKey: CONTACT_SALES_BUTTON_TEXT_KEY
    },
    [CONTACT_SALES_WEBSITE_CRM_FORM_ID]: {
        leadSource: WEBSITE_CONTACT_SALES_LEAD_SOURCE,
        preSelectedProduct: "Sales & CRM",
        submitButtonTextKey: CONTACT_SALES_BUTTON_TEXT_KEY
    }
};
/**
 * Returns metadata for a new-style form ID (leadSource, preSelectedProduct),
 * or null for legacy form IDs where these are still driven by CMS props.
 */ export const getFormMetadata = (formId)=>{
    var _NEW_FORM_METADATA_formId;
    return (_NEW_FORM_METADATA_formId = NEW_FORM_METADATA[formId]) !== null && _NEW_FORM_METADATA_formId !== void 0 ? _NEW_FORM_METADATA_formId : null;
};
/**
 * Form IDs that are enabled for the contact-flow API (BAM + ADA/Tim)
 * Only forms with all required fields (email, company_size, products) should be included.
 */ export const CONTACT_FLOW_ENABLED_FORM_IDS = [
    CONTACT_SALES_HUBSPOT_FORM_ID,
    CONTACT_SALES_LANDING_PAGE_SERVICE_FORM_ID,
    CONTACT_SALES_LANDING_PAGE_CRM_FORM_ID,
    CONTACT_SALES_LANDING_PAGE_WORK_MANAGEMENT_FORM_ID,
    CONTACT_SALES_EXPANSION_FORM_ID
];
/**
 * Checks if contact-flow is enabled for a specific form.
 * 
 * @param {string} formId - The HubSpot form ID
 * @returns {boolean} True if the form has contact-flow enabled
 */ export const isContactFlowEnabledForForm = (formId)=>{
    return CONTACT_FLOW_ENABLED_FORM_IDS.includes(formId);
};
const getOverrideParamsForCampaigin = (campaignId)=>{
    if (campaignId === IPO_CAMPAIGN_ID) {
        return {
            titleKey: "contactSales.hubspotForm.form.ipoCampaignFieldTitle.howCanHelp",
            placeholderKey: "contactSales.hubspotForm.form.ipoCampaignFieldPlaceholder.howCanHelp"
        };
    }
    return null;
};
// Forms whose V2 question labels use the HubSpot form's wording instead of the default floating-label copy
const FORM_IDS_WITH_HUBSPOT_LABELS = [
    CONTACT_SALES_LANDING_PAGE_GENERAL_FORM_ID
];
const getContactSalesConfig = ({ formId, campaignId, withSubmitNotice, formTitle, lastNameFirst, isV2, firstFormSubmitted, preSelectedProduct, submitButtonText })=>{
    const overrideParams = getOverrideParamsForCampaigin(campaignId);
    const shouldHideProductQuestion = preSelectedProduct && preSelectedProduct !== "";
    const useHubspotLabels = FORM_IDS_WITH_HUBSPOT_LABELS.includes(formId);
    const getFirstNameLastNameRow = (withPlaceHolder = false)=>{
        const row = withPlaceHolder ? [
            HUBSPOT_FIRSTNAME_INPUT_WITH_PLACEHOLDER,
            HUBSPOT_LASTNAME_INPUT_WITH_PLACEHOLDER
        ] : [
            HUBSPOT_FIRSTNAME_INPUT,
            HUBSPOT_LASTNAME_INPUT
        ];
        return lastNameFirst ? row.reverse() : row;
    };
    const getProductQuestionRow = (withPlaceHolder = false)=>{
        if (withPlaceHolder) {
            return useHubspotLabels ? HUBSPOT_PRODUCT_QUESTION_INPUT_WITH_HUBSPOT_LABEL : HUBSPOT_PRODUCT_QUESTION_INPUT_WITH_PLACEHOLDER;
        }
        return HUBSPOT_PRODUCT_QUESTION_INPUT;
    };
    const resolveSubmitButtonText = ()=>{
        if (submitButtonText) return submitButtonText;
        return withSubmitNotice ? "contactSales.hubspotForm.form.submitButton" : "contactSales.hubspotForm.form.contactUsButton";
    };
    const getMainFormConfig = ()=>{
        if (isV2) {
            const rows = [
                getFirstNameLastNameRow(true),
                [
                    HUBSPOT_EMAIL_INPUT_WITH_PLACEHOLDER
                ],
                [
                    HUBSPOT_JOBTITLE_INPUT_WITH_PLACEHOLDER
                ],
                [
                    HUBSPOT_PHONE_INPUT
                ],
                [
                    HUBSPOT_COMPANY_INPUT_WITH_PLACEHOLDER,
                    HUBSPOT_COMPANYSIZE_INPUT_WITH_PLACEHOLDER
                ]
            ];
            if (!shouldHideProductQuestion) {
                rows.push([
                    getProductQuestionRow(true)
                ]);
            }
            rows.push([
                getHubspotHowCanHelpInput(overrideParams, useHubspotLabels)
            ]);
            return {
                formTitle,
                rows,
                submitButtonText: resolveSubmitButtonText()
            };
        }
        const rows = [
            getFirstNameLastNameRow(),
            [
                HUBSPOT_EMAIL_INPUT,
                HUBSPOT_JOBTITLE_INPUT
            ],
            [
                HUBSPOT_PHONE_INPUT
            ],
            [
                HUBSPOT_COMPANY_INPUT,
                HUBSPOT_COMPANYSIZE_INPUT
            ]
        ];
        if (!shouldHideProductQuestion) {
            rows.push([
                getProductQuestionRow()
            ]);
        }
        rows.push([
            getHubspotHowCanHelpInput(overrideParams)
        ]);
        return {
            formTitle,
            rows,
            submitButtonText: resolveSubmitButtonText()
        };
    };
    switch(formId){
        case CONTACT_SALES_HUBSPOT_FORM_ID:
        case TEST_CONTACT_SALES_HUBSPOT_FORM_ID:
        case CONTACT_SALES_LANDING_PAGE_SERVICE_FORM_ID:
        case CONTACT_SALES_LANDING_PAGE_CRM_FORM_ID:
        case CONTACT_SALES_LANDING_PAGE_AGENT_FACTORY_FORM_ID:
        case CONTACT_SALES_LANDING_PAGE_WORK_MANAGEMENT_FORM_ID:
        case CONTACT_SALES_LANDING_PAGES_FDES_FORM_ID:
        case CONTACT_SALES_LANDING_PAGE_MONDAY_VIBE_FORM_ID:
        case CONTACT_SALES_LANDING_PAGE_GENERAL_FORM_ID:
        case CONTACT_US_MOBILE_CONTACT_SALES_FORM_ID:
        case CONTACT_SALES_EXPANSION_FORM_ID:
        case CONTACT_SALES_WEBSITE_CRM_FORM_ID:
            return getMainFormConfig();
        case REQUEST_A_DEMO_HUBSPOT_FORM_ID:
            return {
                rows: [
                    getFirstNameLastNameRow(true),
                    [
                        HUBSPOT_EMAIL_INPUT,
                        HUBSPOT_JOBTITLE_INPUT
                    ],
                    [
                        HUBSPOT_PHONE_INPUT
                    ],
                    [
                        HUBSPOT_COMPANY_INPUT,
                        HUBSPOT_COMPANYSIZE_INPUT
                    ],
                    [
                        getProductQuestionRow()
                    ],
                    [
                        HUBSPOT_HOWPLANUSE_INPUT
                    ]
                ]
            };
        case REPORT_FORM_ID:
            return {
                rows: [
                    getFirstNameLastNameRow(),
                    [
                        HUBSPOT_EMAIL_INPUT,
                        HUBSPOT_JOBTITLE_INPUT
                    ],
                    [
                        HUBSPOT_PHONE_INPUT
                    ],
                    [
                        HUBSPOT_COMPANY_INPUT,
                        HUBSPOT_COMPANYSIZE_INPUT
                    ]
                ],
                submitButtonText: "contactSales.hubspotForm.form.getReport"
            };
        case NURTURE_CONTACT_US_FORM_ID:
            return {
                rows: [
                    getFirstNameLastNameRow(true),
                    [
                        HUBSPOT_EMAIL_INPUT
                    ],
                    [
                        getProductQuestionRow()
                    ],
                    [
                        getHubspotHowCanHelpInput(overrideParams)
                    ]
                ],
                submitButtonText: "contactSales.hubspotForm.form.getInTouch",
                privacyNoticeText: "forms.getInTouch.privacyNotice"
            };
        case EMAIL_ONLY_FORM_ID:
            return {
                rows: [
                    [
                        HUBSPOT_EMAIL_INPUT
                    ]
                ],
                submitButtonText: "Submit"
            };
        case EVENTS_HUBSPOT_FORM_ID:
            return {
                formTitle,
                rows: [
                    getFirstNameLastNameRow(true),
                    [
                        HUBSPOT_EMAIL_INPUT,
                        HUBSPOT_JOBTITLE_INPUT
                    ],
                    [
                        HUBSPOT_PHONE_INPUT
                    ],
                    [
                        HUBSPOT_COMPANY_INPUT,
                        HUBSPOT_COMPANYSIZE_INPUT
                    ]
                ],
                submitButtonText: "contactSales.hubspotForm.form.register"
            };
        default:
            return {
                rows: []
            };
    }
};
export const getContactFormConfigById = ({ formId, overrideCampaignId = null, withSubmitNotice = true, formTitle, lastNameFirst, isV2, firstFormSubmitted, privacyNoticeText, ctaProps = {}, preSelectedProduct, submitButtonText })=>{
    const formData = getContactSalesConfig({
        formId,
        overrideCampaignId,
        withSubmitNotice,
        formTitle,
        lastNameFirst,
        isV2,
        firstFormSubmitted,
        preSelectedProduct,
        submitButtonText
    });
    return _object_spread_props(_object_spread({}, formData), {
        ctaProps,
        privacyNoticeText: privacyNoticeText || formData.privacyNoticeText
    });
};
